import { Button } from "../ui/button";
import { Plus } from "lucide-react";
import { type SocialLink, SocialsList } from "./SocialsList";
import { SocialEditForm } from "./SocialEditForm";
import { useSocialsManager } from "./useSocialsManager";

interface AdminSocialsTabProps {
  socials: SocialLink[];
  onRefresh: () => void;
}

export function AdminSocialsTab({ socials, onRefresh }: AdminSocialsTabProps) {
  const sortedSocials = [...socials].sort((a, b) => a.sort_order - b.sort_order);
  const {
    editingSocial,
    setEditingSocial,
    activeDraft,
    setActiveDraft,
    startAdd,
    handleEdit,
    handleSaveDraft,
    handleDiscardDraft,
    handleSave,
    handleDelete,
    handleMove
  } = useSocialsManager(socials, onRefresh);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center pb-2 border-b border-border/80 text-left">
        <div>
          <h4 className="text-xl font-bold text-foreground uppercase tracking-wider">Social Links</h4>
          <p className="text-xs text-muted-foreground mt-0.5">Manage socials cards displayed on the contact page</p>
        </div>
        {!editingSocial && (
          <Button onClick={startAdd} className="bg-brand-primary text-white">
            <Plus className="h-4 w-4 mr-2" /> Add Social Link
          </Button>
        )}
      </div>

      {editingSocial ? (
        <SocialEditForm
          editingSocial={editingSocial}
          setEditingSocial={setEditingSocial}
          onSave={handleSave}
          onCancel={() => {
            setEditingSocial(null);
            setActiveDraft(null);
          }}
          socials={socials}
          activeDraft={activeDraft}
          onSaveDraft={handleSaveDraft}
          onDiscardDraft={handleDiscardDraft}
          liveSocial={socials.find((s) => s.name === editingSocial.name)}
        />
      ) : (
        <SocialsList
          sortedSocials={sortedSocials}
          handleMove={handleMove}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
}

export default AdminSocialsTab;
